<template>
  <div class="section">
    <div class="box">
      <breadcrumbs :data="list_breadcrumbs"></breadcrumbs>
      <div class="section">
        <div class="is-pulled-right">
          <!-- <router-link class="button is-primary" :to="basepath+'sortable/'+parent_id">Sortable</router-link> -->
          <router-link class="button is-success" :to="basepath+'insert/'+parent_id">Insert</router-link>
        </div>
      </div>
      <table class="table is-fullwidth">
        <tr>
          <th>Title</th>
          <th>Member</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
        <tr v-for="(data_row, index) in data_list" :key="index">
          <td v-text="data_row.title"></td>
          <td v-text="data_row.member"></td>
          <td v-text="data_row.active_label"></td>
          <td>
            <table-button-dropdown :modul-path="basepath" :row-data="data_row" :btn-detail="false" :btn-show-hide="false" :btn-update="false"
              :btn-delete="false">
              <div name="bottom">
                <router-link class="dropdown-item" :to="'/panel/division/team/' + data_row.id">Team</router-link>
                <router-link class="dropdown-item" :to="'/panel/division/campus_coordinator/menu/' + parent_id + '/' + data_row.id">Menu</router-link>
                <router-link class="dropdown-item" :to="'/panel/division/campus_coordinator/update/' + parent_id + '/' + data_row.id">Update</router-link>
              </div>
            </table-button-dropdown>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list_breadcrumbs: [
        {
          title: 'Division',
          path: '/panel/division/'
        },
        {
          title: 'Campus Coordinator',
          path: '/panel/division/campus_coordinator/'
        }
      ],
      basepath: '/panel/division/campus_coordinator/',
      parent_id: '',
      data_list: []
    }
  },
  created () {
    if (this.getSessionItem('id_token') === null || this.getSessionItem('access_token') === null) {
      this.$router.push('/panel/logout')
    }
    this.parent_id = this.$route.params.parent_id
    this.getData()
  },
  methods: {
    getData () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('head/campus_coordinator', {
        id: this.parent_id
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.data_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/division/campus_coordinator/Home.vue